module.exports = __webpack_public_path__ + "static/fonts/Fact-CondensedExtraLight.2276238.woff2";